<template>
  <div
    class="flex justify-between items-center gap-4 bg-EXPONDO-grey-5 w-full p-2 lg:p-4"
  >
    <div v-if="back">
      <slot name="back">
        <SfButton
          aria-label="back"
          class="ex-button--pure sf-bar__icon"
          type="button"
          @click="$emit('click:back')"
        >
          <span class="iconify svg--chevron-left text-xl" />
        </SfButton>
      </slot>
    </div>
    <div class="flex-1 min-h-[1.5rem]">
      <slot
        name="title"
        v-bind="{ title }"
      >
        <div>
          {{ title }}
        </div>
      </slot>
    </div>
    <div v-if="close">
      <slot name="close">
        <CloseButton
          @click="$emit('click:close')"
        />
      </slot>
    </div>
  </div>
</template>

<script lang="ts">

export default defineComponent({
  name: 'SfBar',

  props: {
    title: {
      type: String,
      default: '',
    },
    back: {
      type: Boolean,
      default: false,
    },
    close: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['click:back', 'click:close'],
});

</script>
